import { render, staticRenderFns } from "./PuzzleDetails.vue?vue&type=template&id=1caeae99&scoped=true"
import script from "./PuzzleDetails.vue?vue&type=script&lang=js"
export * from "./PuzzleDetails.vue?vue&type=script&lang=js"
import style0 from "./PuzzleDetails.vue?vue&type=style&index=0&id=1caeae99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caeae99",
  null
  
)

export default component.exports